import React from 'react'
import { ReactComponent as Arrow } from '../icon/arrow-right.svg';
import { ReactComponent as Youtube } from '../icon/youtube.svg';

const ButtonLink: React.FC<{ text: string, href: string, img: string, coupon?: string, perc?: number, price?: number, youtube?: string }> = ({ coupon, text, href, img, perc, price, youtube }) => {

    return <a href={href} className='button'>
        <img className='buttonImgIcon' src={img}></img>
        <div className='alignDiv'>

            <div className='verticalDiv'>
                <span>{text}</span>
                {coupon && <span className='coupon'>COUPON: {coupon}</span>}
                {coupon && perc && <span className='coupon'>sconto del {perc}%</span>}
                {coupon && price && <span className='coupon'>prezzo fisso {price}€</span>}
            </div>
            <div className='iconDiv'>
                {youtube && <a href={youtube}><Youtube stroke='var(--white20)' width={24} height={24} /></a>}
                <Arrow stroke='var(--white20)' width={24} height={24} />
            </div>
        </div>

    </a>
}

export default ButtonLink